import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-delete-confirmation',
  templateUrl: './delete-confirmation.component.html',
  styleUrls: ['./delete-confirmation.component.scss'],
})
export class DeleteConfirmationDialogComponent {
  constructor(
    private readonly matDialogRef: MatDialogRef<DeleteConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { confirmationText: string },
  ) {}

  onConfirm() {
    this.matDialogRef.close({ confirmed: true });
  }

  onDecline() {
    this.matDialogRef.close({ confirmed: false });
  }
}
